import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, withStyles } from '@material-ui/styles';
import ChipInput, {
  StandardTextFieldProps as ChipInputProps,
} from 'material-ui-chip-input';
import React from 'react';

const styles = (theme: JupiterTheme) =>
  createStyles({
    chip: {
      background: theme.palette.background.dark,
      color: theme.palette.primary.main,
      margin: theme.spacing(0, 0, 1, 0.5),
      '&&:hover, &&:focus': {
        background: theme.palette.background.dark,
        '& svg': {
          fill: theme.palette.primary.main,
          '&:hover, &:focus': {
            fill: theme.palette.primary.main,
          },
        },
      },
      '& svg': {
        fill: theme.palette.primary.main,
      },
      '& > span': {
        color: theme.palette.primary.main,
      },
    },
    chipContainer: {
      margin: `0 -${theme.spacing(0.5)}px`,
    },
    chipInputRoot: {
      color: theme.palette.coolGrey[50],
    },
    chipLabel: {
      color: theme.palette.primary.main,
    },
    chipLabelFocused: {
      '&&': {
        color: theme.palette.primary.main,
      },
    },
    chipUnderline: {
      '&:before': {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
      },
      '&:hover:before': {
        borderBottom: `1px solid ${theme.palette.grey[200]} !important`,
      },
    },
    chipInput: {
      marginLeft: theme.spacing(1),
    },
    labelShrink: {
      marginTop: theme.spacing(-0.5),
    },
  });

interface Props extends ChipInputProps {
  classes: any;
}

const QuestionChipInput = ({ classes, ...props }: Props) => {
  return (
    <ChipInput
      variant="filled"
      classes={{
        root: classes.chipInputRoot,
        chip: classes.chip,
        chipContainer: classes.chipContainer,
        input: classes.chipInput,
        underline: classes.chipUnderline,
        labelShrink: classes.labelShrink,
      }}
      InputLabelProps={{
        classes: {
          root: classes.chipLabel,
          focused: classes.chipLabelFocused,
        },
      }}
      {...props}
    />
  );
};

export default withStyles(styles)(QuestionChipInput);
